import type { ReactElement } from "react"
import UnderlineLinkAtm from "@onestore/hel/dist/components/atoms/UnderlineLinkAtm"
import type Theme from "@onestore/hel/dist/typings/theme"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import ModalTemplateWrapper from "~/components/ModalTemplateWrapper"
import type { TermLink as TermLinkType } from "~/fragments/termLink"
import useModalState from "~/hooks/useModalState"
import isEmpty from "~/lib/isEmpty"
import { getSummaryTerms } from "~/store/checkout-terms/selectors"
import { useAppSelector } from "~/store/hooks"

type TermModalLinkProps = Omit<TermLinkType["flatData"], "isDisplayInModal"> & {
  typography?: Theme.Typography
  emphasis?: Theme.Emphasis
}

const TermModalLink = ({
  text,
  title,
  termId,
  typography,
  emphasis,
}: TermModalLinkProps): ReactElement<TermModalLinkProps> | null => {
  const { isOpen, open, close } = useModalState()
  const terms = useAppSelector(getSummaryTerms)

  const searchedTerm = terms.find((term) => term.id === termId)

  if (isEmpty(searchedTerm)) {
    return null
  }

  const termTextElement = (
    <MarkdownText
      components={getBaseMarkdownOverrides({
        typography: "medium1_h",
        boldTypography: "medium2_h",
      })}
      hasBoldedLinks
      hasOpenedLinksInNewTab
    >
      {searchedTerm.text}
    </MarkdownText>
  )

  return (
    <>
      <UnderlineLinkAtm
        typography={typography || "medium1_h"}
        title={title}
        onClick={open}
        emphasis={emphasis}
        openInNewTab
      >
        {text}
      </UnderlineLinkAtm>

      <ModalTemplateWrapper
        title={searchedTerm.name}
        typography="large3"
        isOpen={isOpen}
        onCloseButtonClick={close}
        content={termTextElement}
        isHiddenUnderline
      />
    </>
  )
}

export default TermModalLink
